import React from 'react'
import { Grid, Segment, Divider, Accordion, Header } from 'semantic-ui-react'
import MediaQuery from 'react-responsive'

import PesquisaNomeEvento from './PesquisaNomeEvento'
import Tags from './Tags'
import Switch from './Switch'
import Ordenacao from './Ordenacao'
import Mensagens from '../../../Mensagens';

class PesquisaEventos extends React.Component {


    constructor() {
        super()

        this.state = {
            loading: false,
            activeIndex: -1
        }
    }
    handleAccordion(e, titleProps) {
       
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }
    render() {

        let pesquisaEventos = <PesquisaNomeEvento onSearch={this.props.eventHandlers.onSearch} />
        let tags = <Tags eventos={this.props.eventos} filtros={this.props.filtros} onSelectTag={this.props.eventHandlers.onSelectTag} />
        let ordenacao = <Ordenacao onChangeOrder={this.props.eventHandlers.onChangeOrder} />
        let switchHoje = <Switch label={Mensagens.p11} onChangeCheck={this.props.eventHandlers.onChangeCheck} name='exibirSoHoje' value={this.props.switchDefaultValues.exibirSoHoje} />
        let switchTodos = <Switch label={Mensagens.p12} onChangeCheck={this.props.eventHandlers.onChangeCheck} name='exibirTodos' value={this.props.switchDefaultValues.exibirTodos} />
        let switchInscrito = <Switch label={Mensagens.p13} onChangeCheck={this.props.eventHandlers.onChangeCheck} name='exibirInscritas' value={this.props.switchDefaultValues.exibirInscritas} />

        return <div>



            <Divider />
            <Segment
                disabled={this.state.loading}
                loading={this.state.loading}
                style={{ padding: '0px' }}
                className='resetBackground resetCorners resetBorders'  >

                <div className='search'>
                    {/*Smartphones */}
                    <MediaQuery maxWidth={599}>

                        <Accordion >
                            <Accordion.Title active={this.state.activeIndex === 0} index={0} onClick={(e, t) => this.handleAccordion(e, t)}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width="16">
                                            <Header as='h2' icon='dropdown' className='titulo t2' content={Mensagens.m55} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Accordion.Title>

                            <Accordion.Content active={this.state.activeIndex === 0}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width="16">
                                            {pesquisaEventos}
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Grid.Column width="16">
                                            {tags}
                                        </Grid.Column>
                                    </Grid.Row>
                                    {this.props.icSwitchInscritos &&
                                        <Grid.Row>
                                            <Grid.Column width='16'>
                                                {switchInscrito}
                                            </Grid.Column>
                                        </Grid.Row>
                                    }
                                    <Grid.Row>
                                        <Grid.Column width="16">
                                            {switchHoje}
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width="16">
                                            {switchTodos}
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width="16">
                                            {ordenacao}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Accordion.Content>
                        </Accordion>
                    </MediaQuery>

                    {/*computador */}
                    <MediaQuery minWidth={600}>
                        <Accordion >
                            <Accordion.Title active={this.state.activeIndex === 0} index={0} onClick={(e, t) => this.handleAccordion(e, t)}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width='3'>
                                        <Header as='h4' icon='dropdown' className='titulo t2' content={Mensagens.m55} /> 
                                        </Grid.Column>

                                        <Grid.Column width='13'>
                                            <Grid verticalAlign='middle' style={{ marginTop: '16px' }}>
                                                <Grid.Row>
                                                    <Grid.Column width="16">
                                                        {pesquisaEventos}
                                                    </Grid.Column>
                                                </Grid.Row>


                                            </Grid>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Accordion.Title>
                            <Accordion.Content active={this.state.activeIndex === 0}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width='3'></Grid.Column>
                                        <Grid.Column width='13'>
                                            <Grid verticalAlign='middle'>
                                                <Grid.Row>
                                                    <Grid.Column width='16'>
                                                        {tags}
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    {this.props.icSwitchInscritos &&
                                                        <Grid.Column width='5'>
                                                            {switchInscrito}
                                                        </Grid.Column>
                                                    }
                                                    <Grid.Column width="5">
                                                        {switchHoje}
                                                    </Grid.Column>
                                                    <Grid.Column width="6">
                                                        {switchTodos}
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row>

                                                    <Grid.Column width="16">
                                                        {ordenacao}
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </Grid.Column>
                                    </Grid.Row>

                                </Grid>
                            </Accordion.Content>
                        </Accordion>
                    </MediaQuery>
                </div>
            </Segment>
            <Divider />
        </div >
    }







}

export default PesquisaEventos



// WEBPACK FOOTER //
// ./src/components/Eventos/Pesquisa/PesquisaEventos.js